// extracted by mini-css-extract-plugin
module.exports = {"calendar":"Calendar_calendar__1cz5p","selected":"Calendar_selected__2a6I5","today":"Calendar_today__3XWpp"};